import { QueryClient } from '@tanstack/react-query'

/**
 * Client TanStack Query du back-office (cf. `docs/ARCHITECTURE.md` **D21**).
 *
 * C'est une **fabrique**, pas une instance exportée : un client partagé entre les tests
 * ferait fuiter le cache d'un test au suivant — exactement ce que la convention de test
 * interdit (`docs/CONVENTIONS-TESTS.md` § 4).
 *
 * ⚠️ Rappel de frontière (**D17**) : les `queryFn` de cette app tapent l'API HTTP (à terme
 * `@ghp/api-client`), jamais la base. `@ghp/db`, `drizzle-*`, `pg` et `pg-boss` sont
 * interdits ici — règle ESLint vérifiée en CI.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Le back-office est un outil de bureau utilisé en sessions longues : sans
        // fraîcheur minimale, chaque remontage d'écran redéclenche une requête réseau.
        staleTime: 30_000,
        retry: 1,
        // Le refetch au retour de focus produit des rechargements surprenants sur des
        // écrans de saisie/validation. À rouvrir écran par écran si le besoin apparaît.
        refetchOnWindowFocus: false,
      },
    },
  })
}
